module.exports = __webpack_public_path__ + "static/media/fuunel_illustration.84babb02.svg";